import { ref } from 'vue'
import mitt from 'mitt'

export const eventBus = mitt()

export const BottomSheetStates = {
	get FULLSCREEN() {
		return window.innerHeight - getSafeAreaInsetTop()
	},
	get LARGE() {
		return window.innerHeight * 0.8
	},
	get NORMAL() {
		return window.innerHeight * 0.6
	},
	get SMALL() {
		return window.innerHeight * 0.23
	},
	get HIDDEN() {
		return 0
	},
	get AUTOFIT() {
		return -1
	},
}

function getSafeAreaInsetTop() {
	return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sat')) || 0
}

export function setSheetHeight(height, duration = 300, source = '') {
	eventBus.emit('sheet-height', { height, duration, source })
}

export function closeOtherMenus() {
	eventBus.emit('close-menus')
}
